import { render, staticRenderFns } from "./policy-tab.vue?vue&type=template&id=4018f3ca&scoped=true&"
import script from "./policy-tab.vue?vue&type=script&lang=js&"
export * from "./policy-tab.vue?vue&type=script&lang=js&"
import style0 from "./policy-tab.vue?vue&type=style&index=0&id=4018f3ca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4018f3ca",
  null
  
)

export default component.exports